import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const WorkStationManagement = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        İş İstasyonu Yönetimi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>İş istasyonu yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default WorkStationManagement;
